import React from "react";
import { FieldMetaProps, FieldAttributes } from "formik";

export function ErrorMessage(props: { children: React.ReactNode }) {
  return (
    <>
      {props.children instanceof Array
        ? [...new Set(props.children)].map((e, i) => (
            <span className="help is-danger w-100" key={i}>
              {e}
            </span>
          ))
        : props.children && (
            <span className="help is-danger w-100">{props.children}</span>
          )}
    </>
  );
}

export function getErrorMessageFromMeta(meta: FieldMetaProps<any>) {
  const initialError =
    meta.value === meta.initialValue ? meta.initialError : null;
  const error = (meta.touched && meta.error) || initialError;
  return error;
}

export function doesMetaHaveError(meta: FieldMetaProps<any>) {
  return !!getErrorMessageFromMeta(meta);
}

export function renderErrorMessage(meta: FieldMetaProps<any>) {
  return <ErrorMessage>{getErrorMessageFromMeta(meta)}</ErrorMessage>;
}

export type FieldNameOrOptions =
  | { fieldName: string }
  | { fieldOptions: FieldAttributes<any> };

export function getFieldOptions(props: FieldNameOrOptions) {
  return "fieldName" in props ? props.fieldName : props.fieldOptions;
}
